import * as Yup from "yup";

const validationSchema = Yup.object({

    fullName: Yup.string()

        .required("نام و نام خانوادگی الزامی است."),

});

export default validationSchema;